import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface ValidateUserMfaParams {
	readonly code: string;
}

@Injectable({ providedIn: 'root' })
export class ValidateUserMfaApiMutation extends ApiMutation<
	void,
	ValidateUserMfaParams
> {
	client = 'iam';
	document = gql`
		mutation ValidateUserMfa($code: String!) {
			validateUserMfa(code: $code)
		}
	`;
	method = 'validateUserMfa';
}
